import type { ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { BodyM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useFacet } from '@sorare/core/src/contexts/graphql-search';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Toggle } from '#src/searchCards/Toggle/index.tsx';
import { ToggleFilter } from '#src/searchCards/ToggleFilter/index.tsx';

const FILTER = TOGGLE_FILTERS.bidToEarnFilter;

const BID_TO_EARN_URL_PARAM = 'b2e';

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => <ToggleFilter filter={FILTER} on={['true']} autoHide />,
  accordionOptions: { startsOpen },
});

const BackendFilter = () => {
  const { refine, value, items } = useFacet(BID_TO_EARN_URL_PARAM);
  const isRefined = !!value.length;
  const onValueCount = items.find(item => item.value === 'true')?.count ?? 0;

  const track = useEvents();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    track('Use Market Filter', {
      filterName: FILTER.attribute,
      filterValue: newValue.toString(),
    });
    refine(() => (newValue ? ['true'] : []));
  };

  if (!isRefined && !onValueCount) {
    return null;
  }

  return (
    <Toggle>
      <Switch
        checked={isRefined}
        onChange={handleChange}
        label={
          <BodyM bold>
            <FormattedMessage {...FILTER.label} />
          </BodyM>
        }
      />
    </Toggle>
  );
};

export const backendWidget = (): FilterWidget => ({
  key: `${FILTER.attribute}_backend`,
  type: 'toggle',
  attribute: BID_TO_EARN_URL_PARAM,
  Component: BackendFilter,
});
